import React from 'react';
import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react';

const WizardFooter = ({
  currentStep,
  onBack,
  onNext,
  onSkip,
  canGoNext,
  isLoading,
  skipKnowledge,
}) => {
  const isFirstStep = currentStep === 1;
  const isLastStep = currentStep === 4;

  return (
    <div className="awc-footer">
      <div className="awc-footer__left">
        {!isFirstStep && (
          <button
            className="awc-btn awc-btn--secondary"
            onClick={onBack}
            disabled={isLoading}
            aria-label="Voltar ao passo anterior"
          >
            <IconArrowLeft size={16} />
            Voltar
          </button>
        )}
        {isFirstStep && (
          <button className="awc-btn awc-btn--link" onClick={onSkip}>
            Criar manualmente
          </button>
        )}
      </div>
      <div className="awc-footer__right">
        {!isLastStep && (
          <button
            className="awc-btn awc-btn--primary"
            onClick={onNext}
            disabled={!canGoNext || isLoading}
            aria-label="Avançar para o próximo passo"
          >
            {isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm" />
                Processando...
              </>
            ) : (
              <>
                Próximo
                <IconArrowRight size={16} />
              </>
            )}
          </button>
        )}
      </div>
    </div>
  );
};

export default WizardFooter;
